import { InquiryApi } from "@app/shared/sdk";
import { InquiriesService } from "./inquiries.service";

/** An inquiry database that the data source uses to retrieve data for the table. */
export class InquiryDatabase {
    constructor(
      private _inquiryApi: InquiryApi,
      private _inquiriesService: InquiriesService
    ) {}
  
    getData(sort?, order?, page?, search?): Promise<any> {
      const searchParam = search || "";
      if (!page.pageSize) {
        page.pageSize = 10;
      }
      if (!searchParam) {
        return new Promise((resolve, reject) => {
          this._inquiryApi
            .find({
              limit: page.pageSize,
              skip: page.pageIndex * page.pageSize,
              order: "createdAt DESC",
              include: ["player", "playerPrize"],
            })
            .subscribe(
              (inquires: any[]) => {
                this._inquiriesService.getInquiresCount().then((response) => {
                  this._inquiriesService.noOfInquires = response;
                  this._inquiriesService.noOfInquiresAtStart = response;
                  resolve(inquires);
                });
              },
              () => {
                // Show the success message
                alert("Internal Server Error!");
                reject();
              }
            );
        });
      } else {
        return new Promise((resolve, reject) => {
          this._inquiryApi
            .find({
              limit: page.pageSize,
              skip: page.pageIndex * page.pageSize,
              order: "createdAt DESC",
              include: [
                {
                  relation: "player",
                  scope: {
                    where: { username: { like: "searchParam", options: "i" } },
                  },
                },
                { relation: "playerPrize" },
              ],
            })
            .subscribe(
              (inquires: any[]) => {
                this._inquiriesService.noOfInquires = inquires.length;
                resolve(inquires);
              },
              () => {
                // Show the success message
                alert("Internal Server Error!");
                reject();
              }
            );
        });
      }
    }
  }